
import * as types from 'actions/action-types';

var initialState = {
    assets: null,
    asset_saved: null,
    assets_pending: false,
    asset_save_pending: false,
    assets_unsubscribe: false,

    asset_selected: null,
    asset_selected_pending: false,
    asset_selected_unsubscribe: false,

    asset_type: null,
};

const AssetReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.ASSETS + '_PENDING': pending('assets'); break;
        case types.ASSETS + '_SAVE_PENDING': save_pending('asset'); break;
        case types.ASSETS + '_SAVE_FULFILLED': save_fulfilled('asset'); break;
        case types.ASSETS + '_FULFILLED': fulfilled('assets'); break;
        case types.ASSETS + '_CLEAR': clear('assets', {}); break;

        case types.ASSET_TYPE + '_SELECTED': selected('asset_type'); break;

        case types.ASSET_SELECTED + '_PENDING': pending('asset_selected'); break;
        case types.ASSET_SELECTED + '_FULFILLED': fulfilled('asset_selected'); break;

        default: break;
    }

    return state;

    function pending(table) {
        state = {
            ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = {
            ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = {
            ...state,
            [table + '_saved']: action.data,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = {
            ...state,
            [table]: action.data,
            [table + '_pending']: false,
            [table + '_unsubscribe']: (action.unsubscribe) ? action.unsubscribe : state[table + '_unsubscribe'],
        };
    }
    function selected(table) {
        state = {
            ...state,
            [table]: action.data,
        };
    }
    function clear(table, value) {
        state = {
            ...state,
            [table]: value,
        };
    }
};
export default AssetReducer;


